import React, { useMemo, useEffect } from 'react'
import { Button, Input, Option, Select, Textarea } from '@material-tailwind/react'
import _ from 'lodash'
import { P } from '../../../components/typography/typography'
import constants from '../../../constants/constants'
import Multiselect from 'multiselect-react-dropdown';
import FileUpload from './FileUpload'
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";

const QuestionaireContainer = ({ postedQuestion, formik, isAdmin, togglePopUp, selectedQuestionForReview}: any) => {
  const styles = {
    inputField : {
      padding : '1%'
    },
    loadingIcon :{
      paddingLeft : '50%'
    }
  }

  const onChangeRequestSelected = (question : any) =>{
    selectedQuestionForReview(question);
    togglePopUp();
  }

 useEffect(() => {
  let initialValues: { [key: string]: any } = { };
  postedQuestion?.map((question: any) => {
    initialValues[question?.id as keyof typeof initialValues] = question?.answer || ''; // Set the answer value here
  });

  formik.setValues({ ...initialValues });
}, [postedQuestion]);

  const builder = (question: any) => {
    let answerOptions
    let existingValues :{ [key: string]: any } = [];
    if (!_.isEmpty(question?.answerOptions)) {
      answerOptions = question?.answerOptions.split(',')
    }
    switch (question?.questionType) {
      case constants?.questionTypes?.explanation:
        return (
          <div className="grid grid-cols-11 gap-1">
            <div className="col-span-11 justify-center flex" title={question?.helpText}>
              <label style={{ fontWeight: 'bold' }}>{question?.label}</label>
              
              <br />
            </div>
          </div>  
            )
      case constants?.questionTypes?.singleLine:
      case constants?.questionTypes?.url:
      case constants?.questionTypes?.phoneNumber:
      case constants?.questionTypes?.currency:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
              <br></br>
            </div>
            <div className="col-span-5 w-full ">
              <Input
                //label={question?.label}
                //autoComplete='off'
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                type="text"
                required={question?.required}
                //onChange={formik.handleChange}
                onChange={(text) => {formik.setFieldValue(question?.id.toString(), text.target.value)}}
                onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
                //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
                value={formik.values[`${question?.id.toString()}`]}
                name={question?.id.toString()}
                disabled={isAdmin}
              />
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
              {(formik.touched[question?.id] && formik?.errors[question?.id] )? <P className="text-red-600">{formik?.errors[question?.id]  as React.ReactChild}</P> : null}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
      case constants?.questionTypes?.multiLine:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Textarea
                //label={question?.label}
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                required={question?.required}
                //onChange={formik.handleChange}
                name={question?.id.toString()}
                onChange={(text) => {formik.setFieldValue(question?.id.toString(), text.target.value)}}
                //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
                disabled={isAdmin}
                onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
                value={formik.values[`${question?.id.toString()}`]}
              />
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
              {(formik.touched[question?.id] && formik?.errors[question?.id]) ? <P className="text-red-600">{formik?.errors[question?.id]  as React.ReactChild}</P> : null}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
      case constants?.questionTypes?.email:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Input
                //label={question?.label}
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                type="email"
                required={question?.required}
               // onChange={formik.handleChange}
               onChange={(text) => {formik.setFieldValue(question?.id.toString(), text.target.value)}}
               //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
               name={question?.id.toString()}
               disabled={isAdmin}
               onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
               value={formik.values[`${question?.id.toString()}`]}

              />
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
              {(formik.touched[question?.id] && formik?.errors[question?.id]) ? <P className="text-red-600">{formik?.errors[question?.id]  as React.ReactChild}</P> : null}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
        case constants?.questionTypes?.file:
        return (
          <FileUpload question={question} formik={formik} isAdmin={isAdmin} onChangeRequestSelected={onChangeRequestSelected}></FileUpload>
        )
      case constants?.questionTypes?.singleSelectDropdown:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Select
                //label={question?.label}
                //onChange={formik.handleChange}
                // value={formik.values.question?.label}
                //value={question?.id.toString()}
                //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                onChange={(value) => formik.setFieldValue(question?.id.toString(), value)}
                disabled={isAdmin}
                onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
                value={formik.values[`${question?.id.toString()}`]}
              >
                {answerOptions.map((answer: any) => (
                  <Option value={answer}>{answer}</Option>
                ))}
              </Select>
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
      case constants?.questionTypes?.multiSelectDropdown :
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Multiselect
                // label={question?.label} 
                isObject={false}
                options={answerOptions}
                onSelect={(value) => formik.setFieldValue(question?.id.toString(), value)}
                onRemove={(value) => formik.setFieldValue(question?.id.toString(), value)}
                selectedValues={question?.answer.split(',')}
                //displayValue="name"
                className="mb-10"
                placeholder='Select'
                displayValue=''

                
              >
              </Multiselect>
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
      case constants?.questionTypes?.date:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Input
                //label={question?.label}
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                type="date"
                required={question?.required}
                //onChange={formik.handleChange}
                name={question?.id.toString()}
                onChange={(text) => {formik.setFieldValue(question?.id.toString(), text.target.value)}}
                onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
                //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
                disabled={isAdmin}
                value={formik.values[`${question?.id.toString()}`]}
              />
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
      case constants?.questionTypes?.time:
        return (
          <div className="grid grid-cols-11 gap-1" style={styles.inputField}>
            <div className="col-span-5 w-full" title={question?.helpText}>
              <label>{question?.label}</label>
              {question?.required ? <label style={{ color: 'red' }}>*</label> : ''}
            </div>
            <div className="col-span-5 w-full">
              <Input
                //label={question?.label}
                className="mb-5 bg-blue-grey-50 border-t-blue-grey-200 focus:border-t-blue-500"
                type="time"
                required={question?.required}
                //onChange={formik.handleChange}
                name={question?.id.toString()}
                onChange={(text) => {formik.setFieldValue(question?.id.toString(), text.target.value)}}
                onBlur={() => formik.setFieldTouched(question?.id.toString(), true)}
                //defaultValue={formik.initialValues[`${question?.id.toString()}`]}
                disabled={isAdmin}
                value={formik.values[`${question?.id.toString()}`]}
              />
              {/* {formik.errors && <P className="text-red-600">{formik.errors}</P>} */}
            </div>
            <div className="col-span-1 ">
             { isAdmin && 
             <Menu placement={"bottom-end"} offset={{ mainAxis: 8 }}>
                <MenuHandler>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                  </svg>
 
                </MenuHandler>
                <MenuList>
                <MenuItem onClick={()=>{onChangeRequestSelected(question)}}>
                  <div className="flex items-center gap-2 text-grey-500 width=20 ">
       
                    <div>Change Request</div>
                  </div>
                </MenuItem>
                </MenuList>
                </Menu>}
            </div>
          </div>
        )
    }
  }
  const emptyResponse = () =>{
    return (
      <div style={styles.loadingIcon} >
   <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    </div>
    )
  }
  return (
    <>
      {postedQuestion.length > 0 ? 
      postedQuestion.map((question: any) => {
        return builder(question)
      }) :
      emptyResponse()
    }
    </>
  )
}

export default QuestionaireContainer
